import { render, staticRenderFns } from "./RechargeList.vue?vue&type=template&id=bf07ad54&scoped=true"
import script from "./RechargeList.vue?vue&type=script&lang=js"
export * from "./RechargeList.vue?vue&type=script&lang=js"
import style0 from "./RechargeList.vue?vue&type=style&index=0&id=bf07ad54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf07ad54",
  null
  
)

export default component.exports